import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { ArrowRight, Menu, PhoneForwarded, X } from "lucide-react";
import NavLinks from "./NavLinks";
import MobileMenu from "./MobileMenu";
import {
  menu,
  close,
  colorLogo,
  colorLogoWhite,
  whiteLogo,
} from "../../../assets";
import { HoverBorderGradient } from "../../ui/hover-border-gradient";

import { Link, NavLink } from "react-router-dom";

const RealtyHeader = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
  const closeMenu = () => setIsMenuOpen(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const links = [
    { name: "Home", path: "/realty" },
    { name: "About Us", path: "/realty/about-us" },
    { name: "Listings", path: "/realty/listings" },
    { name: "Blog", path: "/realty/blog" },
    { name: "Careers", path: "/realty/careers" },
    // { name: "Contact Us", path: "/realty/RealtyContact" },
  ];

  return (
    <header>
      <motion.nav
        className={`fixed top-0 left-0 right-0 z-50 bg-black text-white shadow-lg transition-all duration-300 ${
          scrolled ? "py-3" : "py-3"
        }`}
        initial={{ y: -100 }}
        animate={{ y: 0 }}
        transition={{ duration: 0.3, ease: "easeOut" }}
      >
        <div className="container mx-auto px-4 flex justify-between items-center">
          <Link to="/realty">
            <motion.img
              className="object-cover cursor-pointer w-[70px] lg:w-[100px] lg:h-[100px]"
              alt="logo"
              whileHover={{ scale: 1.02 }}
              transition={{ duration: 0.2 }}
              src="/images/realty/realty-logo.png"
            />
          </Link>

          {/* Desktop Navigation */}

          <div className="hidden lg:flex space-x-1 items-center">
            {links.map((link) => (
              <NavLink
                key={link.name}
                to={link.path}
                className={({ isActive }) =>
                  `text-base  navlink-styles px-4 py-2 transition duration-200 hover:text-gold hover:scale-105 hover:opacity-80 ${
                    window.location.pathname === link.path
                      ? "text-gold font-semibold underline underline-offset-4"
                      : "text-white font-medium"
                  }`
                }
              >
                {link.name}
              </NavLink>
            ))}
            {/* <Link
              to="/realty/Contact"
              className="bg-gradient text-slate-900 font-semibold py-1 ps-5 pe-1.5 rounded-full hover:opacity-80 transition duration-200 inline-flex items-center gap-2"
            >
              Contact Us
              <span className="bg-black text-white p-2 rounded-full">
                <ArrowRight size={16} />
              </span>
            </Link> */}

            <NavLink
              to="/"
              className={({ isActive }) =>
                `text-base navlink-styles items-center pr-4 pl-0 py-2 transition duration-200 hover:text-gold hover:scale-105 hover:opacity-80 ${
                  isActive
                    ? "text-gold font-semibold"
                    : "text-white font-medium"
                }`
              }
            >
              <img
                src={`${scrolled ? colorLogoWhite : colorLogoWhite}`}
                alt="Main Logo"
                height={35}
                width={35}
                className="cursor-pointer "
              />
              Holdings
            </NavLink>
            <Link
              // to="https://www.scanglobalrealty.com/"
              to="/solutions"
              // target="_blank"
              rel="noopener noreferrer"
              className="navlink-styles py-1  pr-5 flex gap-1 items-center"
            >
              <img
                src="/images/solutions/mini-logo.png"
                className="w-8 h-8 object-cover"
              />
              Advisory
            </Link>

            <Link to="/realty/contact" className="space-x-2">
              <HoverBorderGradient
                containerClassName="rounded-full"
                as="button"
                className="group  bg-white/5 backdrop-blur-md text-white font-semibold py-1.5 ps-5 pe-1.5 rounded-full hover:opacity-80 transition duration-200 inline-flex items-center gap-2 leading-normal"
              >
                Contact Us
                <span className="bg-white text-slate-900 p-2 rounded-full transition-transform duration-300 group-hover:rotate-[45deg]">
                  <PhoneForwarded size={18} />
                </span>
              </HoverBorderGradient>
            </Link>

            {/* <Link
              to="/realty/contact"
              className="flex justify-center gap-2 items-center mx-auto shadow-xl text-base bg-gradient text-slate-900 backdrop-blur-md lg:font-semibold isolation-auto border-gray-50 before:absolute before:w-full before:transition-all before:duration-700 before:hover:w-full before:-left-full before:hover:left-0 before:rounded-full before:bg-gold hover:text-slate-900 hover:border-gold before:-z-10 before:aspect-square before:hover:scale-150 before:hover:duration-700 relative z-10 ps-4 pe-1 py-1 overflow-hidden border-2 rounded-full group"
            >
              Contact Us
              <svg
                className="w-8 h-8 justify-end group-hover:rotate-90 group-hover:bg-gray-50 ease-linear duration-300  bg-black text-white p-2 rounded-full group-hover:border-none rotate-45"
                viewBox="0 0 16 19"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M7 18C7 18.5523 7.44772 19 8 19C8.55228 19 9 18.5523 9 18H7ZM8.70711 0.292893C8.31658 -0.0976311 7.68342 -0.0976311 7.29289 0.292893L0.928932 6.65685C0.538408 7.04738 0.538408 7.68054 0.928932 8.07107C1.31946 8.46159 1.95262 8.46159 2.34315 8.07107L8 2.41421L13.6569 8.07107C14.0474 8.46159 14.6805 8.46159 15.0711 8.07107C15.4616 7.68054 15.4616 7.04738 15.0711 6.65685L8.70711 0.292893ZM9 18L9 1H7L7 18H9Z"
                  className="fill-white group-hover:fill-gray-800"
                />
              </svg>
            </Link> */}
            {/* <NavLink
              to="/solutions/ContactUs"
              className="bg-gradient text-slate-900 font-semibold py-1 ps-5 pe-1.5 rounded-full hover:opacity-80 transition duration-200 inline-flex items-center gap-2"
            >
              Contact Us
              <span className="bg-black text-white p-2 rounded-full">
                <ArrowRight size={16} />
              </span>
            </NavLink> */}
          </div>

          {/* Mobile Menu Button */}
          <motion.button
            className="lg:hidden text-white p-2"
            whileTap={{ scale: 0.9 }}
            onClick={toggleMenu}
            aria-label={isMenuOpen ? "Close menu" : "Open menu"}
          >
            <motion.div
              initial={false}
              animate={{ rotate: isMenuOpen ? 90 : 0 }}
              transition={{ duration: 0.3 }}
            >
              {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </motion.div>
          </motion.button>
        </div>
      </motion.nav>

      {/* Mobile Menu */}
      <MobileMenu isOpen={isMenuOpen} onLinkClick={closeMenu} />
    </header>
  );
};

export default RealtyHeader;
